var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState } from 'react';
import { getFormSummary } from '../../../../application/usecases/getFormSummary';
import { useAuthStore } from '../../../../application/stores/auth.store';
const useSummary = () => {
    const [summaryForm, setSummaryForm] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const { companyId } = useAuthStore();
    useEffect(() => {
        if (!companyId)
            return;
        const fetch = () => __awaiter(void 0, void 0, void 0, function* () {
            setIsLoading(true);
            try {
                const result = yield getFormSummary(companyId);
                setSummaryForm(result);
            }
            catch (error) {
                console.error('Error al obtener resumen del formulario:', error);
                setSummaryForm([]);
            }
            finally {
                setIsLoading(false);
            }
        });
        fetch();
    }, [companyId]);
    return { summaryForm, isLoading };
};
export default useSummary;
